import { data } from '../../svg/Tax/data';
import { makeIcon } from '../makeIcon';

export const Tax = makeIcon(data, 'tax', 'Tax');

export default Tax;
